import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

type SendVerificationPayload = {
  email?: string;
  displayName?: string;
};

export async function sendVerificationEmail(payload: SendVerificationPayload) {
  const fn = httpsCallable(functions, "sendVerificationEmail");
  await fn(payload);
}
